"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuccessCircle = function SuccessCircle() {
  return _react2.default.createElement(
    "g",
    { id: "tickcircle" },
    _react2.default.createElement("path", {
      d: "M250,0 C111.93,0 0,111.93 0,250 C0,388.07 111.93,500 250,500 C388.07,500 500,388.07 500,250 C500,111.93 388.07,0 250,0 Z M193.73,358.35 L102.91,267.53 L126.91,243.53 L194.44,311.06 L374.74,141.38 L398,166.11 L193.73,358.35 Z",
      id: "Shape"
    })
  );
};

exports.default = SuccessCircle;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/SuccessCircle.js
// module id = 2993
// module chunks = 4